import pcaData from "./pca.data";
import request from "../request";

export const getRegion = () => {
  const url = `/region_province/find_all`;
  return request.get(url);
};

export const getRegionForRoles = () => {
  const url = `/region_province/list`;
  return request.get(url);
};

export const getProvince = () => {
  return pcaData.map((i) => {
    const { code, name } = i;
    return { code, name };
  });
};

export const getCityByProvince = (p) => {
  const province = pcaData.filter((data) => data.code == p);
  if (province.length) {
    return province[0].children.map((i) => {
      const { code, name, children } = i;
      return { code, name, children };
    });
  }
  return [];
};
